var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_4524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_4524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3181,
    cy: 16.4393,
    rx: 65.7576,
    ry: 58.3333,
    fill: "#1DBF73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_175_4524",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_175_4524",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADkwAAA5MBGFUPVAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARgSURBVHic7Z1Na1VHHIefSKjNwq1ZuLJfIAtXinYhBVGkUGhFC9oPIG71G7gRXAQKRdQvIGI3pS2U1lekti6kCBZKF8WXIoiCSUnq6+J4Md7kxjNz5+U/+f8emJ33Zs48z5nrmRtxAmGRCWAL8AmwCdgIPAXuA9eBX4CFarMT2fgAOALcBV6tMuaBWWC6zjRFDmaAv1hd/PCYAw7VmKxIy2d0MkPkLx0n6D42RIN8DjwjXv5gnAbWFZ67GJNU8hVBg6SWrwgaIpd8RdAAueUrAsOUkq8IDFJaviIwRC35isAAteUrgopYka8IKrAXW/IH4xt0bFyEaeA29YWvNE5mvG6xBMsRHMx43WIJG4E/qC98eDwENmS8brEEqzvB4ZwXLd7FYgQ/ZL1isQxrHwf38l7u2mcm4jWWdoLFiPmLN+yje84/EfFaKzvBg4i5C+AA8Jy3C3k84j0s7ASXI+btnmH5LUdwLGLOrhls+6MWtKWPg6fo3xUEMerOb3Un0N0fQF/5rURwHn0h1Jv3bfutfRz8CExFzM0lXzDeV7rWIpD8AMaVby0CyQ8glXwrEUh+AKnl145A8gPIJb9WBJIfQG75pSOQ/ABKyS8VgeQHUFp+7ggkP4Ba8nNFIPkB1JafOgLJD8CK/FQRSH4A+7ElfzBiv0D6Gvgw4rUusXbnp9gJRE+sy1cEGWlFviLIQGvyFUFCWpWvCBLQunxFMAZWH/Vix1dpl2dts1bu/MH4Hj3n90byHSP5jpF8x0i+YyTfMZLvGMl3jOQ7RvIdI/mOkXzHSL5jJN8x1v6zBckviOQ7RvIdI/mOkXzHSL5jJN8xku8YyXeM5DtG8h0j+Y6RfMdIvmMk3zGS7xjJd4zkO0byHSP5jpF8x0i+YyTfMZLvGMl3zDQwT31pqcZ3wPqkK+SA3cAC9eXpzq9I6xFIfgJajUDyE9JaBJKfgVYikPyMWI9A8gPYDKyLeN2nwCL1ZQ8PPeoFMgucJS4CazuB7vwIfqNbvNYjkPwIpnh3G281AsmPZAfLF/MMbUUg+WNwlJUXtZUIJH9MLjB6ca1HIPkJeMDqixwbwR7yRiD5CdhMv8W2FoHkJ+JL+i+6lQgkPyGzhC1+7QgkPzGDA6AWIpD8xAwfAFmOQPIzsNIBkMUIJD8Tow6ALEUg+RlZ7QDIQgSSn5n3HQDVjEDyM9P3AKhGBJJfgJADoJIRSH4hQg+AQsYpYCJiTtvRr3EV43fyBTDOTiAKMAX8T94AFIFhPia/fEVgmGOUC0ARGORbygbwCjiNIjBDygMgRdAYOQ6A+o47wK78lyhGMQlsK/jz/gZ+Aq4BF4F/Cv5ssQKTwNZM7/0C+BO4Sif9Z+BRpp8lIkkZwHPgFm/v8CvAk0TvLTIxAfxHdxAUyhxwnU70JeAG3dm9aIhJuieAj3r82cd02/llOuk36e560TgHgZcs/xv6v8A54Agwgx7X1iSDb+h20oXwAviV7g6/U2tSohyvAdGL5jqis2kxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6788c20d00722ccd13becc1dfab1d2f5.svg";
export { ForwardRef as ReactComponent };